import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useNotifications } from "@itemgo/core";
/**
 * Show toast notifications when new unread notifications arrive.
 * Uses sonner for toasts and useNotifications for Firestore data.
 */
export function usePushToasts() {
    const { notifications, unreadCount } = useNotifications();
    const prevUnreadRef = useRef(unreadCount);
    const lastNotifiedIdRef = useRef(null);
    useEffect(() => {
        // Only show toast when unread count increases
        if (unreadCount > prevUnreadRef.current && notifications.length > 0) {
            const latest = notifications[0];
            // Avoid duplicate toasts for the same notification
            if (latest.id !== lastNotifiedIdRef.current) {
                lastNotifiedIdRef.current = latest.id;
                toast(latest.title, {
                    description: latest.body,
                    duration: 5000,
                });
            }
        }
        prevUnreadRef.current = unreadCount;
    }, [unreadCount, notifications]);
}
//# sourceMappingURL=usePushToasts.js.map